(() => {
  if (customElements.get('gh-wrist-preview')) return;
  class WristPreview extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], () => {});
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.stage = this.querySelector('.gh-wrist__stage');
      this.dragHint = this.querySelector('[data-drag-hint]');
      this.watch = this.querySelector('.gh-wrist__watch');
      this.watchDrag = this.querySelector('[data-watch-drag]');
      this.setupWatchDrag();
      this.setupStacks();
      this.status = this.querySelector('[data-status]');
      this.camera = this.querySelector('[data-camera]');
      this.captureButton = this.querySelector('[data-capture]');
      this.saveButton = this.querySelector('[data-save]');
      this.retakeButton = this.querySelector('[data-retake]');
      this.shot = this.querySelector('[data-shot]');
      this.setupPhotoLayout();
      this.captureButton.addEventListener('click', () => this.capture());
      this.saveButton.addEventListener('click', () => this.save());
      this.retakeButton.addEventListener('click', () => this.retake());
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.querySelector('[data-open]').addEventListener('click', () => this.open());
      this.addEventListener('gh-wrist-open-from-gallery', event => this.open(event.detail));
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        this.finishOpening();
        this.dialog.classList.remove('gh-wrist__dialog--from-gallery');
        this.stop();
        document.body.style.overflow = this.previousOverflow || '';
        this.querySelector('[data-open]').focus();
      });
      this.querySelectorAll('[data-size]').forEach(button => button.addEventListener('click', () => this.size(Number(button.dataset.size))));
      this.camera.addEventListener('click', () => this.start());
      this.visibility = () => { if (document.hidden && this.dialog.open && !this.sharing) this.dialog.close(); };
      document.addEventListener('visibilitychange', this.visibility);
      this.pageHide = () => { this.finishOpening(); this.stop(); };
      window.addEventListener('pagehide', this.pageHide);
    }
    setupPhotoLayout() {
      const section = this.querySelector('.gh-wrist__stacks');
      if (!section) return;
      this.stackPanel = document.createElement('div');
      this.stackPanel.className = 'gh-wrist__stack-collapse';
      const inner = document.createElement('div');
      inner.className = 'gh-wrist__stack-collapse-inner';
      section.before(this.stackPanel);
      this.stackPanel.append(inner);
      inner.append(section);
    }
    setPhotoLayout(captured) {
      this.dialog.classList.toggle('gh-wrist__dialog--photo', captured);
      if (this.stackPanel) {
        this.stackPanel.inert = captured;
        this.stackPanel.setAttribute('aria-hidden', String(captured));
      }
      this.querySelector('.gh-wrist__scroll-content').scrollTop = 0;
    }
    open(source) {
      if (this.dialog.open) return;
      this.finishOpening();
      this.dialog.classList.toggle('gh-wrist__dialog--from-gallery', Boolean(source));
      const shutter = source && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && typeof this.dialog.animate === 'function';
      if (shutter) this.dialog.classList.add('gh-wrist__dialog--shutter');
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.setWatchPosition(0);
      this.size(15);
      if (shutter) this.openShutter(source);
      this.trackEvent('gh_ar_open');
    }
    openShutter(source) {
      const rect = this.dialog.getBoundingClientRect();
      const width = this.dialog.clientWidth;
      const height = this.dialog.scrollHeight;
      if (!width || !height) {
        this.finishOpening();
        return;
      }
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.classList.add('gh-wrist__shutter');
      svg.style.height = `${height}px`;
      const blades = Array.from({length: 6}, (_, i) => {
        const blade = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        blade.setAttribute('fill', ['#f5eee3', '#eee4d5', '#f7f0e6', '#e9decd', '#f3eadd', '#ece1d1'][i]);
        svg.appendChild(blade);
        return blade;
      });
      this.openingShutter = svg;
      const cx = width / 2;
      const cy = rect.height / 2;
      const radius = Math.hypot(width, rect.height);
      const outer = Math.hypot(width, height) * 3;
      const draw = progress => {
        const eased = progress * progress * (3 - 2 * progress);
        const aperture = radius * eased;
        const angle = (30 + 48 * eased) * Math.PI / 180;
        const point = (r, a) => `${cx + Math.cos(a) * r},${cy + Math.sin(a) * r}`;
        blades.forEach((blade, i) => {
          const a = angle + i * Math.PI / 3;
          const b = a + Math.PI / 3;
          blade.setAttribute('points', [point(aperture, a), point(aperture, b), point(outer, b), point(outer, a)].join(' '));
        });
      };
      draw(0);
      this.dialog.appendChild(svg);
      const x = source.left + source.width / 2 - rect.left - rect.width / 2;
      const y = source.top + source.height / 2 - rect.top - rect.height / 2;
      const scale = Math.max(0.06, Math.min(0.3, source.height / rect.height));
      this.openingAnimation = this.dialog.animate([
        {transform: `translate(${x}px, ${y}px) scale(${scale})`, opacity: 0.75},
        {transform: 'translate(0px, 0px) scale(1)', opacity: 1}
      ], {duration: 1100, easing: 'cubic-bezier(.22,.75,.24,1)', fill: 'both'});
      this.openingAnimation.onfinish = () => this.finishOpening();
      let start;
      const tick = time => {
        if (!this.dialog.open) {
          this.finishOpening();
          return;
        }
        if (start === undefined) start = time;
        const progress = Math.min(1, Math.max(0, (time - start - 100) / 900));
        draw(progress);
        if (progress < 1) this.openingFrame = requestAnimationFrame(tick);
      };
      this.openingFrame = requestAnimationFrame(tick);
    }
    finishOpening() {
      cancelAnimationFrame(this.openingFrame);
      this.openingFrame = null;
      if (this.openingAnimation) {
        this.openingAnimation.onfinish = null;
        this.openingAnimation.cancel();
        this.openingAnimation = null;
      }
      this.openingShutter?.remove();
      this.openingShutter = null;
      this.dialog?.classList.remove('gh-wrist__dialog--shutter');
    }
    setupWatchDrag() {
      this.dragOffset = 0;
      this.updateWatchPosition();
      this.watch.draggable = false;
      this.watchDrag.tabIndex = -1;
      this.watchDrag.setAttribute('role', 'slider');
      this.watchDrag.setAttribute('aria-label', 'Watch position along your wrist');
      this.watchDrag.setAttribute('aria-valuemin', '0');
      this.watchDrag.setAttribute('aria-valuemax', '100');
      this.watchDrag.addEventListener('pointerdown', event => {
        if (!this.dialog.open || !this.stage.classList.contains('is-camera') || this.shotFile || this.capturePending || this.switching || !event.isPrimary || event.button !== 0) return;
        this.dismissDragHint();
        this.drag = {id: event.pointerId, x: event.clientX, offset: this.dragOffset};
        this.watchDrag.setPointerCapture(event.pointerId);
        this.watchDrag.classList.add('is-dragging');
        event.preventDefault();
      });
      this.watchDrag.addEventListener('click', () => this.dismissDragHint());
      this.watchDrag.addEventListener('pointermove', event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const width = this.stage.getBoundingClientRect().width;
        if (width) this.setWatchPosition(this.drag.offset + (event.clientX - this.drag.x) / width);
      });
      const finish = event => {
        if (this.drag?.id !== event.pointerId) return;
        this.drag = null;
        this.watchDrag.classList.remove('is-dragging');
        if (this.watchDrag.hasPointerCapture(event.pointerId)) this.watchDrag.releasePointerCapture(event.pointerId);
      };
      this.watchDrag.addEventListener('pointerup', finish);
      this.watchDrag.addEventListener('pointercancel', finish);
      this.watchDrag.addEventListener('lostpointercapture', finish);
      this.watchDrag.addEventListener('keydown', event => {
        if (!this.dialog.open || !this.stage.classList.contains('is-camera') || this.shotFile || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.dismissDragHint();
        this.setWatchPosition(this.dragOffset + (event.key === 'ArrowLeft' ? -0.04 : 0.04));
      });
    }
    setWatchPosition(value) {
      this.dragOffset = Math.max(-0.28, Math.min(0, value));
      this.updateWatchPosition();
    }
    updateWatchPosition() {
      this.watch.style.setProperty('--gh-watch-drag-x', `${this.dragOffset * 100}%`);
      this.watchDrag.style.setProperty('--gh-watch-drag-x', `${this.dragOffset * 100}%`);
      this.watchDrag.setAttribute('aria-valuenow', String(Math.round(-this.dragOffset / 0.28 * 100)));
      this.layoutStacks();
    }
    size(cm) {
      if (this.shotFile) this.retake();
      this.wristCm = cm;
      this.querySelectorAll('[data-size]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.size) === cm)));
      const wristWidth = cm * 10 * 0.35;
      const caseWidth = Number(this.dataset.caseWidth);
      const ratio = Number(this.dataset.caseRatio);
      // Keep transparent source-image padding out of the pointer target.
      this.watchDrag.style.width = `${48 * caseWidth / wristWidth}%`;
      this.watch.style.width = `${48 * caseWidth / wristWidth / ratio}%`;
      const caseLength = Number(this.dataset.caseLength);
      const heightRatio = Number(this.dataset.caseHeightRatio);
      this.watch.style.height = caseLength > 0 && heightRatio > 0
        ? `${100 * caseLength / wristWidth / heightRatio}%`
        : 'auto';
      this.watch.style.transform = `translate(-${Number(this.dataset.centerX) * 100}%, -${Number(this.dataset.centerY) * 100}%)`;
      const max = Number(this.dataset.maxWrist);
      this.querySelector('[data-fit]').textContent = max && cm > max ? this.messages.fit : '';
      this.layoutStacks();
    }
    setupStacks() {
      this.stackLayer = this.querySelector('[data-stack-layer]');
      this.stacks = new Map();
      this.stackButtons = Array.from(this.querySelectorAll('[data-stack]'));
      this.stackButtons.forEach(button => button.addEventListener('click', () => {
        if (this.capturePending || !this.stackLayer) return;
        if (this.shotFile) this.retake();
        const key = button.dataset.stack;
        if (this.stacks.has(key)) {
          this.stacks.get(key).image.remove();
          this.stacks.delete(key);
          button.setAttribute('aria-pressed', 'false');
        } else {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.src = button.querySelector('img').src;
          image.className = 'gh-wrist__stack-image';
          image.alt = button.querySelector('span').textContent;
          image.draggable = false;
          image.tabIndex = 0;
          image.setAttribute('role', 'slider');
          image.setAttribute('aria-label', image.alt + ' position along your wrist');
          image.setAttribute('aria-valuemin', '0');
          image.setAttribute('aria-valuemax', '100');
          this.stacks.set(key, {image, key});
          this.stackLayer.append(image);
          this.setupStackDrag(key, image);
          button.setAttribute('aria-pressed', 'true');
        }
        this.layoutStacks();
      }));
      this.stackResize = new ResizeObserver(() => this.layoutStacks());
      this.stackResize.observe(this.stage);
    }
    setupStackDrag(key, image) {
      let drag;
      image.addEventListener('pointerdown', event => {
        if (event.button !== 0 || this.capturePending || this.shotFile || !this.dialog.open) return;
        event.preventDefault();
        this.dismissDragHint();
        const item = this.stacks.get(key);
        if (!item) return;
        drag = {id:event.pointerId, clientX:event.clientX, x:item.x};
        image.setPointerCapture(event.pointerId);
        image.classList.add('is-dragging');
      });
      image.addEventListener('pointermove', event => {
        if (!drag || drag.id !== event.pointerId || this.capturePending) return;
        const item = this.stacks.get(key);
        if (!item) return;
        item.manualX = drag.x + (event.clientX-drag.clientX)/this.stage.clientWidth;
        this.layoutStacks();
      });
      const finish = event => {
        if (!drag || drag.id !== event.pointerId) return;
        drag = null;
        image.classList.remove('is-dragging');
        if (image.hasPointerCapture(event.pointerId)) image.releasePointerCapture(event.pointerId);
      };
      ['pointerup','pointercancel','lostpointercapture'].forEach(name => image.addEventListener(name, finish));
      image.addEventListener('keydown', event => {
        if (this.capturePending || this.shotFile || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.dismissDragHint();
        const item = this.stacks.get(key);
        item.manualX = item.x + (event.key === 'ArrowLeft' ? -.025 : .025);
        this.layoutStacks();
      });
    }
    layoutStacks() {
      if (!this.stacks || !this.stage?.clientWidth) return;
      const wristWidth = (this.wristCm || 15)*10*.35;
      const scale = .48 / wristWidth;
      const watchX = .5 + (this.dragOffset || 0);
      const caseHalf = Number(this.dataset.caseWidth)*scale/2;
      let left = watchX-caseHalf-.027;
      let right = watchX+caseHalf+.027;
      const widths = {tennis:3.1,chain:3.2,deco:5.2,ruby:6,pearl:3.2};
      const artworkWidths = {tennis:13.5,chain:17,deco:21,ruby:22,pearl:13};
      for (const item of this.stacks.values()) {
        const width = widths[item.key]*scale;
        let x;
        if (left-width > .025) {x = left-width/2;left -= width+.019;}
        else {x = Math.min(.96-width/2,right+width/2);right += width+.019;}
        if (item.manualX !== undefined) x = item.manualX;
        else if (item.x !== undefined) x = item.x;
        const minX = width/2+.015;
        const maxX = .5-width/2-.015;
        item.x = Math.max(minX,Math.min(maxX,x));
        if (item.manualX !== undefined) item.manualX = item.x;
        const top = item.x <= .5 ? .242+.021*Math.sin(item.x*Math.PI) : .263-(item.x-.5)*.22;
        const bottom = item.x <= .5 ? .76-.019*Math.sin(item.x*Math.PI) : .741+(item.x-.5)*.22;
        item.image.style.left = `${item.x*100}%`;
        item.image.style.top = `${(top-.022)*100}%`;
        item.image.style.width = `${width*32/artworkWidths[item.key]*100}%`;
        item.image.style.height = `${(bottom-top+.044)*100}%`;
        item.image.setAttribute('aria-valuenow', String(Math.round(item.x*100)));
      }
    }
    showDragHint() {
      this.hideDragHint();
      if (!this.dragHint) return;
      this.dragHint.hidden = false;
      this.dragHint.classList.add('is-visible');
      this.dragHintTimer = window.setTimeout(() => this.hideDragHint(), 2000);
    }
    dismissDragHint() {
      window.clearTimeout(this.dragHintTimer);
      this.dragHintTimer = null;
      if (!this.dragHint || this.dragHint.hidden || this.dragHintFade) return;
      if (typeof this.dragHint.animate !== 'function') {
        this.hideDragHint();
        return;
      }
      this.dragHintFade = this.dragHint.animate([
        {opacity: getComputedStyle(this.dragHint).opacity},
        {opacity: 0}
      ], {duration: 150, easing: 'ease-out', fill: 'forwards'});
      this.dragHintFade.onfinish = () => this.hideDragHint();
    }
    hideDragHint() {
      if (this.dragHintFade) {
        this.dragHintFade.onfinish = null;
        this.dragHintFade.cancel();
        this.dragHintFade = null;
      }
      window.clearTimeout(this.dragHintTimer);
      this.dragHintTimer = null;
      if (!this.dragHint) return;
      this.dragHint.hidden = true;
      this.dragHint.classList.remove('is-visible');
    }
    async start() {
      if (this.pending || this.stream) return;
      if (!navigator.mediaDevices?.getUserMedia || !window.isSecureContext) {
        this.status.textContent = this.messages.unavailable;
        return;
      }
      this.pending = true;
      const request = this.request = (this.request || 0) + 1;
      this.camera.disabled = true;
      this.status.textContent = this.messages.opening;
      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: { ideal: 'environment' }, width: { ideal: 1080 }, height: { ideal: 1080 } } });
        if (!this.isConnected || !this.dialog.open || request !== this.request) {
          stream.getTracks().forEach(track => track.stop());
          return;
        }
        this.stream = stream;
        this.video.srcObject = stream;
        await this.video.play();
        if (request !== this.request || !this.dialog.open) return;
        this.stage.classList.add('is-camera');
        this.watchDrag.tabIndex = 0;
        this.camera.hidden = true;
        this.captureButton.hidden = false;
        this.status.textContent = this.messages.align;
        this.showDragHint();
        this.trackEvent('gh_ar_camera_start');
      } catch (error) {
        stream?.getTracks().forEach(track => track.stop());
        if (request === this.request && this.dialog.open) {
          this.stream = null;
          this.video.srcObject = null;
          this.status.textContent = error.name === 'NotAllowedError' ? this.messages.denied : this.messages.failed;
        }
      } finally {
        if (request === this.request) {
          this.pending = false;
          this.camera.disabled = false;
        }
      }
    }
    async capture() {
      if (!this.stream || this.capturePending || !this.video.videoWidth) return;
      this.hideDragHint();
      this.capturePending = true;
      this.captureButton.disabled = true;
      const request = this.request;
      try {
        await this.watch.decode();
        const capturedStacks = Array.from(this.stacks?.values() || []);
        await Promise.all(capturedStacks.map(item => item.image.decode()));
        if (request !== this.request || !this.dialog.open) return;
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 1080;
        const ctx = canvas.getContext('2d');
        const vw = this.video.videoWidth, vh = this.video.videoHeight;
        const side = Math.min(vw, vh);
        ctx.drawImage(this.video, (vw-side)/2, (vh-side)/2, side, side, 0, 0, 1080, 1080);
        const stage = this.stage.getBoundingClientRect();
        const watch = this.watch.getBoundingClientRect();
        const clip = this.querySelector('.gh-wrist__watch-clip').getBoundingClientRect();
        const k = 1080/stage.width;
        for (const item of capturedStacks) {
          const rect = item.image.getBoundingClientRect();
          ctx.save();
          ctx.shadowColor = 'rgba(43,29,13,.22)';
          ctx.shadowBlur = 2*k;
          ctx.shadowOffsetX = .7*k;
          ctx.shadowOffsetY = 1*k;
          ctx.drawImage(item.image,(rect.left-stage.left)*k,(rect.top-stage.top)*k,rect.width*k,rect.height*k);
          ctx.restore();
        }
        const overlay = document.createElement('canvas');
        overlay.width = overlay.height = 1080;
        const oc = overlay.getContext('2d');
        oc.drawImage(this.watch, (watch.left-stage.left)*k, (watch.top-stage.top)*k, watch.width*k, watch.height*k);
        const top = (clip.top-stage.top)*k, bottom = (clip.bottom-stage.top)*k;
        const fade = (bottom-top)*.04;
        const mask = oc.createLinearGradient(0,0,0,1080);
        mask.addColorStop(0,'transparent');
        mask.addColorStop(top/1080,'transparent');
        mask.addColorStop((top+fade)/1080,'#000');
        mask.addColorStop((bottom-fade)/1080,'#000');
        mask.addColorStop(bottom/1080,'transparent');
        mask.addColorStop(1,'transparent');
        oc.globalCompositeOperation = 'destination-in';
        oc.fillStyle = mask;
        oc.fillRect(0,0,1080,1080);
        ctx.drawImage(overlay,0,0);
        if (this.dataset.borderSrc) {
          const border = new Image();
          border.crossOrigin = 'anonymous';
          border.src = this.dataset.borderSrc;
          await border.decode();
          if (request !== this.request || !this.dialog.open) return;
          ctx.drawImage(border, 0, 0, 1080, 1080);
        }
        if (this.dataset.logoSrc) {
          const logo = new Image();
          logo.crossOrigin = 'anonymous';
          logo.src = this.dataset.logoSrc;
          await logo.decode();
          if (request !== this.request || !this.dialog.open) return;
          const markWidth = 350;
          const markHeight = markWidth * logo.naturalHeight / logo.naturalWidth;
          const markX = 1080 - 28 - markWidth;
          const markY = 1080 - 28 - markHeight;
          ctx.drawImage(logo, markX, markY, markWidth, markHeight);
        }
        const blob = await new Promise(resolve => canvas.toBlob(resolve,'image/jpeg',.94));
        if (!blob) throw new Error('Capture failed');
        if (request !== this.request || !this.dialog.open) return;
        this.showShot(blob);
        this.trackCapture();
      } catch (error) {
        if (request === this.request && this.dialog.open) this.status.textContent = this.messages.capture_failed;
      } finally {
        this.capturePending = false;
        this.captureButton.disabled = false;
      }
    }
    showShot(blob) {
      this.shotFile = new File([blob], 'gilded-hour-wrist-preview.jpg', {type:'image/jpeg'});
      this.shotUrl = URL.createObjectURL(blob);
      this.shot.src = this.shotUrl;
      this.shot.hidden = false;
      this.stage.classList.add('is-captured');
      this.video.pause();
      this.captureButton.hidden = true;
      this.saveButton.hidden = this.retakeButton.hidden = false;
      this.status.textContent = this.messages.captured;
      this.setPhotoLayout(true);
      this.saveButton.focus({preventScroll:true});
    }
    trackCapture() {
      this.trackEvent('wrist_capture', 'gh_wrist_capture');
    }
    trackEvent(name, shopifyName = name) {
      const payload = {
        watch_id:this.dataset.productId,
        watch_name:this.dataset.productName,
        watch_handle:this.dataset.productHandle
      };
      if (window.ghWatchAnalytics) {
        window.ghWatchAnalytics.track(name, payload, shopifyName);
      } else {
        const queue = window.ghWatchEventQueue = window.ghWatchEventQueue || [];
        if (queue.length >= 20) queue.shift();
        queue.push([name, payload, shopifyName]);
      }
    }
    async save() {
      if (!this.shotFile || this.sharing) return;
      const file = this.shotFile;
      if (navigator.canShare?.({files:[file]})) {
        this.sharing = true;
        try {
          await navigator.share({files:[file]});
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        } finally {
          this.sharing = false;
        }
      }
      if (!this.shotUrl) return;
      const link = document.createElement('a');
      link.href = this.shotUrl;
      link.download = file.name;
      document.body.append(link);
      link.click();
      link.remove();
      this.status.textContent = this.messages.saved;
    }
    clearShot() {
      if (this.shotUrl) URL.revokeObjectURL(this.shotUrl);
      this.shotUrl = null;
      this.shotFile = null;
      this.shot.removeAttribute('src');
      this.shot.hidden = true;
      this.stage.classList.remove('is-captured');
      this.setPhotoLayout(false);
      this.saveButton.hidden = this.retakeButton.hidden = true;
    }
    retake() {
      this.clearShot();
      if (this.stream) {
        this.video.play().catch(() => this.stop());
        this.captureButton.hidden = false;
      }
      this.status.textContent = this.messages.align;
    }
    stop() {
      this.hideDragHint();
      this.request = (this.request || 0) + 1;
      this.stream?.getTracks().forEach(track => track.stop());
      this.stream = null;
      this.pending = false;
      this.clearShot();
      this.captureButton.hidden = true;
      this.video.pause();
      this.video.srcObject = null;
      this.stage.classList.remove('is-camera');
      this.watchDrag.tabIndex = -1;
      this.camera.hidden = false;
      this.camera.disabled = false;
      this.status.textContent = this.messages.align;
    }
    disconnectedCallback() {
      if (!this.ready) return;
      this.finishOpening();
      this.stop();
      this.stackResize?.disconnect();
      if (this.dialog.open) document.body.style.overflow = this.previousOverflow || '';
      document.removeEventListener('visibilitychange', this.visibility);
      window.removeEventListener('pagehide', this.pageHide);
    }
  }
  customElements.define('gh-wrist-preview', WristPreview);
})();
